import type { Components, Theme } from "@mui/material/styles";

export const MuiDialogContent: Components<Theme>["MuiDialogContent"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(3),
      padding: theme.spacing(3),

      // have to override the base theme
      ".MuiDialogTitle-root+&": {
        paddingTop: theme.spacing(3),
      },
    }),
  },
};
